import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Presentation from "./components/Presentation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Presentation />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
